<div class="users flex flex-col justify-between h-full">
	<div class="form-group p-4">
		<div class="title-resources w-full flex justify-start pb-3">
			<span class="font-lato text-lg text-complementary-color-a font-bold"> Form name </span>
		</div>
		<div class="pb-3 flex justify-between">
			<div class="flex">
				<img
					class="mr-4"
					src="../../../../../../assets/icon/akar-icons_edit.svg"
					alt=""
					srcset=""
				/>
				<input
					type="text"
					class="text-neutral-color-b rounded-xl pl-3 text-base font-lato w-72"
					placeholder="Type the name of the group form"
				/>
			</div>
			<div class="buttons flex items-center justify-end pr-4">
				<button class="px-3" (click)="desingForm()">
					<mat-icon class="text-primary-color mr-2"> add </mat-icon>
					<span class="font-lato">Design Form</span>
				</button>
			</div>
		</div>
	</div>
	<div class="title-resources w-full flex justify-start px-4 pb-4">
		<span class="font-lato text-complementary-color-a font-bold text-lg">Form list fields</span>
	</div>
	<div class="h-full">
		<layout-table
			(action)="buttonAction($event)"
			[filterList]="filterList"
			(isLoading)="refreshData($event)"
			[isAdd]="true"
		>
			<app-pagination
				slot="end"
				class="hidden md:block"
				[info]="pagination"
				(emitNavigationPag)="emitNavigation($event)"
			>
			</app-pagination>
			<ngx-datatable
				table
				[columns]="columns"
				[rows]="fieldTable || []"
				class="material fullscreen"
				[columnMode]="modeColum"
				[headerHeight]="50"
				[messages]="{ emptyMessage: '' }"
				[footerHeight]="0"
				[rowHeight]="60"
				[limit]="10"
				[scrollbarH]="false"
				[scrollbarV]="true"
			>
				<ngx-datatable-column
					[width]="30"
					[sortable]="false"
					[canAutoResize]="false"
					[draggable]="false"
					[resizeable]="false"
				>
					<ng-template
						ngx-datatable-header-template
						let-value="value"
						let-allRowsSelected="allRowsSelected"
						let-selectFn="selectFn"
					>
						<input
							type="checkbox"
							[checked]="allRowsSelected"
							(change)="selectFn(!allRowsSelected)"
							src="../../../../assets/icons/refresh-icon.svg"
						/>
					</ng-template>
					<ng-template
						ngx-datatable-cell-template
						let-value="value"
						let-isSelected="isSelected"
						let-onCheckboxChangeFn="onCheckboxChangeFn"
					>
						<input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column [name]="columnsElement.name" *ngFor="let columnsElement of columns">
				</ngx-datatable-column>

				<ngx-datatable-column name="Actions">
					<ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
						<app-actions-table [value]="row"></app-actions-table>
					</ng-template>
				</ngx-datatable-column>
			</ngx-datatable>
		</layout-table>
	</div>
</div>
